<div class="do-wrap">

  <div class="do-toolbar">
    <div>
      <h2 class="do-title">{{ dateLabel() }}</h2>
      <p class="do-note">
        Who is out, how far they are, and what is broken. Everything updates by itself —
        open the stop-by-stop detail in <strong>Dispatch</strong>, the machines in <strong>Issues</strong>.
      </p>
    </div>

    <div class="do-date">
      <button mat-icon-button (click)="shiftDate(-1)" matTooltip="Previous day">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <mat-form-field appearance="outline" class="do-date-field">
        <input matInput type="date" [(ngModel)]="date" (ngModelChange)="onDateChange()">
      </mat-form-field>
      <button mat-icon-button (click)="shiftDate(1)" matTooltip="Next day">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button mat-stroked-button (click)="goToday()" [disabled]="isToday()">Today</button>
    </div>
  </div>

  <!-- the day in six numbers ------------------------------------------------->
  <div class="do-stats">
    <div class="do-stat">
      <span class="do-stat-num">{{ onRoadCount }}</span>
      <span class="do-stat-label">on the road</span>
    </div>
    <div class="do-stat">
      <span class="do-stat-num">{{ notStartedCount }}</span>
      <span class="do-stat-label">not started</span>
    </div>
    <div class="do-stat">
      <span class="do-stat-num">{{ doneRunCount }} / {{ runCount }}</span>
      <span class="do-stat-label">runs finished</span>
    </div>
    <div class="do-stat">
      <span class="do-stat-num">{{ stopsDone }} / {{ stopsTotal }}</span>
      <span class="do-stat-label">kantiner done<span *ngIf="stopsSkipped">, {{ stopsSkipped }} skipped</span></span>
    </div>
    <div class="do-stat do-stat-click" [class.do-stat-bad]="openIssueCount" (click)="openIssues()">
      <span class="do-stat-num">{{ openIssueCount }}</span>
      <span class="do-stat-label">open issues →</span>
    </div>
    <div class="do-stat do-stat-click" [class.do-stat-warn]="unscheduled.length" (click)="openRoutes()">
      <span class="do-stat-num">{{ unscheduled.length }}</span>
      <span class="do-stat-label">routes with no run</span>
    </div>
  </div>

  <div class="do-empty" *ngIf="loading">Loading the day…</div>

  <div class="do-columns" *ngIf="!loading">

    <!-- runs --------------------------------------------------------------->
    <div class="do-main">
      <div class="do-section-head">
        <strong>Runs</strong>
        <span class="do-muted">{{ runCount }} for this day</span>
        <span class="do-spacer"></span>
        <button mat-stroked-button (click)="openDispatch()">
          <mat-icon>monitor_heart</mat-icon> Open Dispatch
        </button>
      </div>

      <div class="do-empty" *ngIf="!runs.length">
        No runs for {{ date }}. Generate one from the list on the right.
      </div>

      <div class="do-run" *ngFor="let r of runs; trackBy: trackByRun"
           [ngClass]="'do-run-' + r.statusClass" (click)="openInDispatch(r)">
        <div class="do-run-top">
          <span class="do-run-name">{{ r.routeName }}</span>
          <span class="do-chip" [ngClass]="'do-chip-' + r.statusClass">{{ r.statusLabel }}</span>
          <span class="do-chip do-chip-bad" *ngIf="r.issueCount">
            {{ r.issueCount }} issue{{ r.issueCount === 1 ? '' : 's' }}
          </span>
          <span class="do-chip do-chip-bad" *ngIf="!r.driverUid">No driver</span>
          <span class="do-spacer"></span>
          <span class="do-open">Open →</span>
        </div>

        <div class="do-run-sub">
          <mat-icon class="do-mini-icon">person</mat-icon>
          <span>{{ r.driverName }}</span>
          <span class="do-covering" *ngIf="r.coveringLabel"> · {{ r.coveringLabel }}</span>
          <ng-container *ngIf="r.driverUid && lastSeen[r.driverUid] as seen">
            · <a class="do-seen" [class.do-seen-stale]="seen.stale" [href]="seen.mapsUrl"
                 target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ seen.label }}</a>
          </ng-container>
        </div>

        <div class="do-where" *ngIf="r.whereLabel">
          {{ r.whereLabel }}<span class="do-muted" *ngIf="r.lastActivity"> · last activity {{ r.lastActivity }}</span>
        </div>

        <div class="do-progress">
          <div class="do-progress-bar">
            <div class="do-progress-fill" [ngClass]="'do-fill-' + r.statusClass"
                 [style.width.%]="r.progressPct"></div>
          </div>
          <span class="do-progress-label">{{ r.completedStopCount }} / {{ r.stopCount }}</span>
        </div>

        <div class="do-run-foot do-muted">
          <span *ngIf="r.expectedLabel">{{ r.expectedLabel }}</span>
          <span *ngIf="r.pickedUpAt"> · loaded {{ r.pickedUpAt }}</span>
          <span *ngIf="r.completedAt"> · finished {{ r.completedAt }}</span>
          <span *ngIf="r.skippedStopCount"> · {{ r.skippedStopCount }} skipped</span>
        </div>
      </div>
    </div>

    <!-- side: missing runs + issues ---------------------------------------->
    <div class="do-side">

      <div class="do-panel">
        <div class="do-section-head">
          <strong>No run for this day</strong>
          <span class="do-chip" *ngIf="unscheduled.length">{{ unscheduled.length }}</span>
        </div>

        <p class="do-muted do-panel-note">
          <strong>Usually nothing to do here.</strong> A driver's own route appears by itself the
          moment they open the app, with the stops due that weekday. Generate only to see a day
          before the driver starts, to give the round to someone else, or to include stops that
          weekday would skip — generating here takes the <strong>whole</strong> route.
        </p>

        <div class="do-empty" *ngIf="!unscheduled.length">
          Every active route has a run. Nothing to do here.
        </div>

        <div class="do-gen" *ngFor="let u of unscheduled; trackBy: trackByRoute">
          <div class="do-gen-head">
            <span class="do-gen-name">{{ u.name }}</span>
            <span class="do-muted">{{ u.stopCount }} kantiner</span>
          </div>
          <div class="do-gen-row">
            <mat-form-field appearance="outline" class="do-gen-driver">
              <mat-label>Driver</mat-label>
              <mat-select [(ngModel)]="genDriver[u.id]">
                <mat-option value="">— unassigned —</mat-option>
                <mat-option *ngFor="let d of activeDrivers" [value]="d.uid">
                  {{ d.name || d.email }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="generate(u)"
                    [disabled]="u.generating || !canEdit">
              {{ u.generating ? 'Generating…' : 'Generate run' }}
            </button>
          </div>
        </div>
      </div>

      <div class="do-panel">
        <div class="do-section-head">
          <strong>Open issues</strong>
          <span class="do-chip do-chip-bad" *ngIf="openIssueCount">{{ openIssueCount }}</span>
          <span class="do-spacer"></span>
          <button mat-button (click)="openIssues()">All issues</button>
        </div>

        <div class="do-empty" *ngIf="!openIssueCount">Nothing open. Machines behaving.</div>

        <div class="do-issue" *ngFor="let i of issues; trackBy: trackByIssue" (click)="openIssues()">
          <div class="do-issue-head">
            <span class="do-issue-system">{{ i.systemName }}</span>
            <span class="do-chip do-chip-bad">{{ i.categoryLabel }}</span>
            <span class="do-spacer"></span>
            <span class="do-muted">{{ i.when }}</span>
          </div>
          <div class="do-issue-note" *ngIf="i.note">{{ i.note }}</div>
        </div>

        <div class="do-muted do-more" *ngIf="openIssueCount > issues.length">
          + {{ openIssueCount - issues.length }} more on the Issues screen
        </div>
      </div>
    </div>
  </div>
</div>
